import { VALUE_TYPE } from "c8-platform";
import { Field } from "csi/def/Field";
import Widget from "csi/form/Widget";
import locale from "csi/locale";
import declare from "dojo/_base/declare";

const NODE_NAME_FIELD = "SustainabilityProfileTemplate";
const SP_TEMPLATE_FORM_FIELDS = [
	"ApplicableForSalesRegions",
	"Description",
	"Subtype",
	"SustainabilityProfileTemplate",
];

const SustainabilityProfileTemplateForm = declare(Widget, {

	/**
	 * @override
	 * Manage node name field
	 */
	_buildFields(fields: Field[]): void {
		this.inherited(arguments);
		if (this.isCopy()) {
			this.setFieldValue(NODE_NAME_FIELD, locale.resource("NAME_COPY", [this.getFieldValue(NODE_NAME_FIELD)]));
		}

		// Hide all fields except SP_TEMPLATE_FORM_FIELDS
		for (const field of fields) {
			if (!SP_TEMPLATE_FORM_FIELDS.includes(field.m_name)) {
				this.setFieldHidden(field, true);
			}
		}
	},

	/**
	 * @override
	 * Set ref/reflist field stores to empty store for hidden fields (SPTemplate, FromBOM, FromCareAndComposition,
	 * ApplicableForColors) to avoid query
	 */
	getFieldStore(field: Field, value: String) {
		if (!SP_TEMPLATE_FORM_FIELDS.includes(field.m_name) && (field.m_type === VALUE_TYPE.REF || field.m_type === VALUE_TYPE.REF_LIST)) {
			const ctx = this.getContext();
			return ctx.view.createHeadingNamesStore(ctx, field, null);
		} else {
			return this.inherited(arguments);
		}
	},

});

export = SustainabilityProfileTemplateForm;
